export default __webpack_public_path__ + "static/media/marker-icon-partner.5340ca83.svg";